// This uses the same colors and same notation for positions as canvas.
import './components/sidebar.lit';
import 'normalize.css';
import { onAuthStateChanged } from 'firebase/auth';
import { game_runner } from './game_runner';
import { init_particles } from './particles';
import { auth } from './firebase';
import router from './scripts/router-config';

window.addEventListener('load', () => {
    init_particles();
    onAuthStateChanged(auth, (user) => router.on_auth_changed(user));
});
